"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var bindRaf = exports.bindRaf = function bindRaf(fn) {
    var isRunning = null;
    var args = null;

    var run = function run() {
        isRunning = false;
        fn.apply(undefined, _toConsumableArray(args));
    };

    return function () {
        for (var _len = arguments.length, invokingArguments = Array(_len), _key = 0; _key < _len; _key++) {
            invokingArguments[_key] = arguments[_key];
        }

        args = invokingArguments;

        if (isRunning) {
            return;
        }

        isRunning = true;
        requestAnimationFrame(run);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-on-visible/build/lib/bindRaf.js
// module id = 345
// module chunks = 104101334113578 186072240823722